// POS = rendering context
// PAS un produit
// PAS un workflow
// PAS une vue métier
//
// Ce fichier expose les constantes et helpers du displayContext.
// Le displayContext est l'unique source de vérité du mode de rendu (default, pos, ...).
// Aucune logique métier ici, uniquement des descripteurs UI.

export const DISPLAY_MODES = Object.freeze({
  DEFAULT: 'default',
  POS: 'pos',
});

export const DEVICE_TYPES = Object.freeze({
  DESKTOP: 'desktop',
  TABLET: 'tablet',
  MOBILE: 'mobile',
});

export const defaultDisplayContext = Object.freeze({
  mode: DISPLAY_MODES.DEFAULT,
  isPos: false,
  device: DEVICE_TYPES.DESKTOP,
  density: 'default',
  interaction: 'mouse',
  surface: 'window',
  preferBottomSheets: false,
  showHoverActions: true,
  touchTargetSize: 40,
});

export function createPosDisplayContext({ isMobile = false, isTablet = false } = {}) {
  const device = isMobile
    ? DEVICE_TYPES.MOBILE
    : isTablet
      ? DEVICE_TYPES.TABLET
      : DEVICE_TYPES.DESKTOP;

  return Object.freeze({
    mode: DISPLAY_MODES.POS,
    isPos: true,
    isMobilePos: isMobile,
    device,
    density: isMobile ? 'compact' : 'comfortable',
    interaction: 'touch',
    surface: 'fullscreen',
    preferBottomSheets: true,
    showHoverActions: false,
    touchTargetSize: isMobile ? 48 : 64,
  });
}

export function isPosContext(ctx) {
  return Boolean(ctx?.isPos);
}
